/**
 * [String value] Backend API base URL for RTK Query (`VITE_API_URL`).
 */
export const API_URL = import.meta.env.VITE_API_URL as string

/**
 * [String value] Google reCAPTCHA v2 (checkbox) site key
 */
export const RECAPTCHA_KEY_V2 = import.meta.env.VITE_RECAPTCHA_KEY_V2 as string

/**
 * [Flag] Indicates if it is development environment
 */
export const DEV_ENV = import.meta.env.DEV

/**
 * [Number value or FALSE ] The time in seconds to refetch the availability data. If false, it will not refetch.
 */
export const AVAILABILITY_REFETCH_EVERY_SECONDS = import.meta.env
  .VITE_AVAILABILITY_REFETCH_EVERY_SECONDS as string | undefined

/**
 * [Number value] Timeout before screensaver in seconds
 */
export const SCREENSAVER_TIMEOUT_SECONDS = import.meta.env
  .VITE_SCREENSAVER_TIMEOUT_SECONDS as string | undefined
